export const downloadXlsx = async (rows: object[], fileName: string, sheetName = 'Sheet1') => {
  const { Workbook } = await import('exceljs');
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  const keys = Array.from(new Set(rows.flatMap((row) => Object.keys(row))));
  worksheet.columns = keys.map((key) => ({ header: key, key }));
  worksheet.addRows(rows);

  const buffer = await workbook.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
};
